import React, { useState, useContext } from "react";
import { Input, Container, Row, Col } from "reactstrap";
import { onChangeItem, onChange } from "../../IO";
import Securities from "./Securities";
import Account from "../../Fields/Account";
import { Field, Combobox } from "../../../Order/Field/Field";
import { TransferType, CurrencyAsset } from "../../../../IO/types";
import { Dispatch } from "../../store/store";
import Files from "../../Fields/Files/Files";

const Transfer = ({opsViewAccountName}) => {
  const { dispatch, services, state } = useContext(Dispatch);
  const { ui, io, fields, entities } = state;
  const { errors, readonly } = fields;
  const header = io.itemsHeader;
  const checkSettlementDate = (tradedate, AssetId) => {
    let settlementvalue = 1;
    //let AssetId = 0;
    let inchange = false;

    onChange(dispatch, { Date: tradedate });

    if (header.IsCurrency === false) {
      if (inchange) {
        // AssetId = values.AssetId;
        services.GetAssetSettlement({ AssetId }).then((r) => {
          executeSettlement(AssetId, r.DefaultSettlement, tradedate);
        });
      } else {
        //AssetId = simpleItem.AssetId;
        services.GetAssetSettlement({ AssetId }).then((r) => {
          executeSettlement(AssetId, r.DefaultSettlement, tradedate);
        });
      }
    } else {
      settlementvalue = 1;
      AssetId = 0;
      executeSettlement(AssetId, settlementvalue, tradedate);
    }
  };
  const executeSettlement = (Asset, settlementvalue, tradedate) => {
    const getdata = {
      tradedate: tradedate,
      assetId: Asset,
      ist0: false,
      settlement: settlementvalue,
    };
    services
      .GetIOSettlementDate(getdata)
      .then((r) => onChange(dispatch, { SettlementDate: r.settlementday }));
  };

  return (
    <Container>
      <Row>
        {/* Left */}
        <Col xs={12} lg={6}>
          {/* ##### Date ##### */}
          <Field label={"Date"} error={errors.Date}>
            <Input
              tabIndex="3"
              type="date"
              placeholder={"Date"}
              disabled={readonly.Date}
              value={io.Date}
              invalid={!!errors.Date}
              onChange={(e) => checkSettlementDate(e.target.value, 0)}
            />
          </Field>

          {/* ##### Settlement Date ##### */}
          <Field label={"Settlement Date"} error={errors.SettlementDate}>
            <Input
              tabIndex="3"
              type="date"
              placeholder={"Settlement Date"}
              disabled={readonly.SettlementDate}
              value={io.SettlementDate}
              invalid={!!errors.SettlementDate}
              onChange={(e) => onChange(dispatch, { SettlementDate: e.target.value })}
            />
          </Field>

          <Securities
            accountId={io.transfersendingId}
            readonly={readonly.Date}
            items={io.items}
            dispatch={dispatch}
            error={errors.items}
            services={services}
            editingItem={ui.editingItem}
            accountType={io.accountType}
          />
        </Col>
        {/* ##### Right ##### */}
        <Col xs={12} lg={6}>
          {/* ##### Account ###### */}
          <Account
            label={"Sending Account"}
            AccountId={io.transfersendingId}
            AccountName={io.transfersendingName}
            AccountNumber={io.transfersendingNumber}
            onChange={(f) => {
              onChange(dispatch, {
                transfersendingId: f.AccountId,
                transfersendingName: f.AccountName,
                transfersendingNumber: f.AccountNumber,
              });
            }}
            filter={[io.transferreceivingId]}
            hideHolder={true}
            readonly={{
              AccountName: readonly.transfersendingName,
            }}
            errors={{
              AccountName: errors.transfersendingName,
            }}
            services={{
              fetchAccountHolders: services.fetchAccountHolders,
              fetchSearchAccount: services.fetchSearchAccount,
            }}
            opsViewAccountName={opsViewAccountName}
          />

          {/* ##### Account ###### */}
          <Account
            label={"Receiving Account"}
            AccountId={io.transferreceivingId}
            AccountName={io.transferreceivingName}
            AccountNumber={io.transferreceivingNumber}
            onChange={(f) => {
              onChange(dispatch, {
                transferreceivingId: f.AccountId,
                transferreceivingName: f.AccountName,
                transferreceivingNumber: f.AccountNumber,
              });
            }}
            filter={[io.transfersendingId]}
            hideHolder={true}
            readonly={{
              AccountName: readonly.transferreceivingName,
            }}
            errors={{
                AccountNumber: errors.transferreceivingNumber,
            }}
            services={{
              fetchAccountHolders: services.fetchAccountHolders,
              fetchSearchAccount: services.fetchSearchAccount,
              fetchSearchTransfer: services.fetchSearchTransfer,
            }}
            sendingAccountId={io.transfersendingId > 0 ? io.transfersendingId : 0}
            opsViewAccountName={opsViewAccountName}
          />

          <Files
            id={io.Id}
            ioType={io.IOType}
            readonly={readonly.Quantity}
            dispatch={dispatch}
            files={io.files}
            downloadFile={services.fetchDownloadIOFile}
          />
        </Col>
      </Row>
    </Container>
  );
};

export const TransferValidations = (io) => {
  return {
    form: {
      transfersendingName: { empty: true },
      transferreceivingNumber: { empty: true },
    },
    subForm: {},
  };
};

export default Transfer;
